import ActionTypes from './actionTypes';

export function loadSelectedReleasesSucceeded(containers) {
  return {
    type: ActionTypes.SELECTED_RELEASES_REQUEST_SUCCEEDED,
    payload: containers,
  };
}
